import { taskFlightCheckListPage } from "../Pages/TaskFlightCheckListPage";

export const modalWarningCheckList = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='debug']", [
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;']", "Предупреждение"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: modalContainerWarningCheckList.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='text-align: center;']", [
                                        m("b[id='titleModalCheckList']", args.title)
                                    ]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m("button.btn.btn-warning.btn-lg", {
                                            id: "",
                                            onclick: function () {
                                                modalContainerWarningCheckList.close();
                                            }
                                        }, "Ок")
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};

export const modalContainerWarningCheckList = {
    container: null,
    init: function () {
        modalContainerWarningCheckList.container = document.querySelector('#modalWarningCheckList');
        if (!modalContainerWarningCheckList.container) {
            modalContainerWarningCheckList.container = document.createElement('div');
            modalContainerWarningCheckList.container.id = 'modalWarningCheckList';
            modalContainerWarningCheckList.container.hidden = true;
            document.body.appendChild(modalContainerWarningCheckList.container);

            m.mount(modalContainerWarningCheckList.container, m.component(modalWarningCheckList, {title: ""}));

        }
    },
    open: function (title) {
        modalContainerWarningCheckList.container = document.querySelector('#modalWarningCheckList');
        if (modalContainerWarningCheckList.container && title != null) {
            document.getElementById("titleModalCheckList").innerText = title;
            modalContainerWarningCheckList.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function () {
        modalContainerWarningCheckList.container.hidden = true;
        taskFlightCheckListPage.errCheckList = null;
        //m.route('/task/' + m.route.param('taskId') + '/info');
    }
};
